import Select, { components } from 'react-select'

import Icon from './Icon'
import React from 'react'

const SelectDropdownIndicator = (props) => {
  return (
    <components.DropdownIndicator {...props}>
      <Icon id="triangle-down" />
    </components.DropdownIndicator>
  )
}

const SelectDropdown = React.memo((props) => {
  const classes = props.classes ? props.classes : ''
  const name = props.instanceId
  const searchable = props.isSearchable ? ' searchable' : ''

  // PATCH: the first parameter of React-Select's onChange is an option value while the first parameter of formik's handleChange is an event
  const patchedOnChange = (value) => {
    props.onChange({ currentTarget: { value, name } })
  }

  const styles = {
    control: (styles, { data, isDisabled, isFocused, isSelected, menuIsOpen }) => {
      return {
        ...styles,
        height:
          props.wStyle == 'dropdown' ? '' : menuIsOpen && props.isSearchable ? '8rem' : '5.5rem',
        outline: isFocused ? '2px solid #000' : 0,
      }
    },
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      return {
        ...styles,
        cursor: 'pointer',
      }
    },
  }

  return (
    <Select
      className={
        (props.wStyle == `dropdown` ? `dropdown ` : `w-form__select w-form__select--dropdown`) +
        ` ${classes}${searchable}`
      }
      classNamePrefix={props.wStyle == `dropdown` ? `dropdown` : `w-form__select`}
      closeMenuOnSelect
      isClearable={false}
      isSearchable={props.isSearchable || false}
      instanceId={props.instanceId}
      inputId={props.inputId}
      name={name}
      isDisabled={props.isDisabled || false}
      defaultValue={props.defaultValue || null}
      placeholder={props.placeholder}
      components={{ DropdownIndicator: SelectDropdownIndicator }}
      onChange={patchedOnChange}
      options={props.options}
      value={props.value}
      styles={styles}
      isMulti={props.isMulti || false}
    />
  )
})

export default SelectDropdown
